const css = `.HDMd9q__tooltipLabel{max-width:400px;text-overflow:ellipsis;overflow:hidden}.HDMd9q__tooltipPill{max-width:100%;border:1px solid var(--base-strokes-default);border-radius:3px;padding:0 4px;display:inline-flex}.HDMd9q__trendsTooltipValues{white-space:nowrap}.HDMd9q__tooltipPartialPeriod{padding-left:2px}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"trendsTooltipValues":"HDMd9q__trendsTooltipValues","tooltipPill":"HDMd9q__tooltipPill","tooltipLabel":"HDMd9q__tooltipLabel","tooltipPartialPeriod":"HDMd9q__tooltipPartialPeriod"};
